module.exports = __webpack_public_path__ + "static/media/angle-up-inputs.c5963fc8.svg";